import axios from "axios";

let API_URL = process.env.REACT_APP_API_URL;
API_URL = API_URL + 'sales-order';



class SalesOrder {
  create = async (SalesOrder) => {
    await axios({
      method: "post",
      url: `${API_URL}`,
      data: SalesOrder,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };

  edit = async (SalesOrder, code) => {
    await axios({
      method: "put",
      url: `${API_URL}/${code}`,
      data: SalesOrder,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
      throw e;
    });
  };

  get = async (code) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.salesOrder;
  };

  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.salesOrders;
  };

  search = async (keyword) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.salesOrder;
  };
}

export default new SalesOrder();
